import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule, CurrencyPipe, PlatformLocation } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SettingsApp } from './settings.app';
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsViewComponent } from './settings-view/settings-view.component';
import { AppPlatformLocation } from 'src/app/routing/app-platform-location';
import { OrganizationEditorViewComponent } from './organization-editor-view/organization-editor-view.component';
import { ResourceListViewComponent } from './resources/resource-list-view/resource-list-view.component';
import { InvitationDialogComponent } from './resources/invitation-dialog/invitation-dialog.component';
import { DialogModule } from '../dialog/dialog.module';
import { ResourceEditorComponent } from './resources/resource-editor-view/resource-editor-view.component';
import { ComponentsModule } from '../components/components.module';
import { WorkDayEditorComponent } from './resources/resource-editor-view/work-day-editor/work-day-editor.component';
import { ExemptionEditorComponent } from './resources/resource-editor-view/exemption-editor/exemption-editor.component';
import { ExemptionEditorDialogComponent } from './resources/resource-editor-view/exemption-editor/exemption-editor-dialog/exemption-editor-dialog.component';
import { AccountingViewComponent } from './accounting-view/accounting-view.component';
import { NotificationsViewComponent } from './notifications-view/notifications-view.component';
import { NotificationTemplateEditorViewComponent } from './notifications-view/notification-template-editor/notification-template-editor-view.component';
import { SecurityEditorComponent } from './resources/resource-editor-view/security-editor/security-editor.component';
import { PipesModule } from '../pipes/pipes.module';
import { GeoModule } from '../geo/geo.module';
import { DeveloperViewComponent } from './developer-view/developer-view.component';
import { PlanningViewComponent } from './planning-view/planning-view.component';
import { SubscriptionViewComponent } from './subscription-view/subscription-view.component';
import { environment } from 'src/environments/environment';
import { StripeComponent } from './subscription-view/stripe/stripe.component';
import { NgxStripeModule } from 'ngx-stripe';
import { SystemSelectionDialogComponent } from './accounting-view/system-selection-dialog/system-selection-dialog.component';
import { DineroConnectionDialogComponent } from './accounting-view/connections-dialogs/dinero-connection-dialog/dinero-connection-dialog.component';
import { BillyConnectionDialogComponent } from './accounting-view/connections-dialogs/billy-connection-dialog/billy-connection-dialog.component';
import { EconomicConnectionDialogComponent } from './accounting-view/connections-dialogs/economic-connection-dialog/economic-connection-dialog.component';
import { ProfileEditorViewComponent } from './profile-editor-view/profile-editor-view.component';

@NgModule({
  declarations: [
    SettingsApp, 
    SettingsViewComponent,
    OrganizationEditorViewComponent,
    ResourceListViewComponent,
    ResourceEditorComponent,
    AccountingViewComponent,
    InvitationDialogComponent,
    NotificationsViewComponent,
    NotificationTemplateEditorViewComponent,
    WorkDayEditorComponent,
    ExemptionEditorComponent,
    ExemptionEditorDialogComponent,
    SecurityEditorComponent,
    DeveloperViewComponent,
    PlanningViewComponent,
    SubscriptionViewComponent,
    StripeComponent,
    SystemSelectionDialogComponent,
    DineroConnectionDialogComponent,
    BillyConnectionDialogComponent,
    EconomicConnectionDialogComponent,
    ProfileEditorViewComponent
  ],
  providers: [
    {
      provide: PlatformLocation,
      useClass: AppPlatformLocation,
      deps: [],
    }
  ],
  imports: [
    CommonModule,
    DialogModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SettingsRoutingModule, 
    ComponentsModule,
    PipesModule,
    GeoModule,
    NgxStripeModule.forRoot(environment.stripeKey)
  ],
  exports: [SettingsApp],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsModule {
  customElementComponent: Type<any> = SettingsApp;

  constructor() { }

  ngDoBootstrap() { }
}
